export const ACCEPTED_TERMS_AND_PRIVACY = 'ACCEPTED_TERMS_AND_PRIVACY';
export const ACCEPTED_MAILINGLIST = 'ACCEPTED_MAILINGLIST';
export const SELECTED_RESTAURANT = 'SELECTED_RESTAURANT';
export const ADD_PEOPLE = 'ADD_PEOPLE';
export const REMOVE_PEOPLE = 'REMOVE_PEOPLE';
export const NEXT_STEP = 'NEXT_STEP';
export const BACK_STEP = 'BACK_STEP';
export const TIME_SELECT = 'TIME_SELECT';
export const DATE_SELECT = 'DATE_SELECT';
export const MENU_SELECT = 'MENU_SELECT';
export const ROOM_SELECT = 'ROOM_SELECT';


// WEBPACK FOOTER //
// ./src/store/actions.js